import React from "react";
import module_style from "../Style.module.css";
import AddCircleOutlinedIcon from "@material-ui/icons/AddCircleOutlined";
import RemoveCircleOutlined from "@material-ui/icons/RemoveCircleOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  EXLY_WEBPAGE_DETAILS__SET_SAVE_CTA,
  EXLY_WEBPAGE_DETAILS__REFETCH_KEYWORDS,
  EXLY_WEBPAGE_DETAILS__STOP_PROCESSING,
} from "ui/pages/TemplatePreview/redux/actions";
import dataProvider from "data/dataProvider";
import api from "data/APIs";
import style from "../../../../../../../Style.module.css";
import { isRequestSuccessful, is_desktop } from "utils/Utils";
import { apiMethods } from "data/api.constants";
import { notification_color_keys, useNotifications } from "utils/hooks";

const CreateKeyword = ({ set_add_keyword, add_keyword }) => {
  const dispatch = useDispatch();
  const keywords = useSelector((state) => state.webpage_detail.keywords);

  const { notify } = useNotifications();

  const [keyword_title, set_keyword_title] = React.useState({ data: [""] });

  React.useEffect(() => {
    dispatch({
      type: EXLY_WEBPAGE_DETAILS__SET_SAVE_CTA,
      save_cta_text: "Add",
      handleSaveCta: handleAdd,
    });
  }, [add_keyword]);

  const handleAdd = async () => {
    try {
      const response = await dataProvider.custom_request(
        api.add_keyword,
        apiMethods.POST,
        { keywords: keyword_title.data }
      );
      if (isRequestSuccessful(response?.status)) {
        dispatch({
          type: EXLY_WEBPAGE_DETAILS__REFETCH_KEYWORDS,
          forceUpdate: true,
        });
        set_keyword_title({ ...keyword_title, data: [] });
        set_add_keyword(false);
      }
      notify(response?.message, notification_color_keys.info);
    } catch (error) {
      notify(
        error?.body?.message ?? "Something went wrong",
        notification_color_keys.error
      );
    } finally {
      dispatch({ type: EXLY_WEBPAGE_DETAILS__STOP_PROCESSING });
    }
  };

  const addKeyword = () => {
    let temp = keyword_title.data;
    temp.push("");
    set_keyword_title({ ...keyword_title, data: temp });
  };

  const removeKeyword = async (keyword) => {
    if (keyword.uuid) {
      try {
        const status = await dataProvider.custom_request(
          api.delete_keyword,
          "POST",
          { keyword_uuid: keyword.uuid }
        );
        if (status.status === 200) {
          dispatch({ type: EXLY_WEBPAGE_DETAILS__REFETCH_KEYWORDS });
          notify(status.message);
        }
      } catch (err) {
        console.log("removeKeyword err", err);
        notify(
          err?.body?.message ? err?.body?.message : "Something went wrong"
        );
      }
    } else {
      let temp = keyword_title.data;
      temp.splice(keyword, 1);
      set_keyword_title({ ...keyword_title, data: temp });
    }
  };

  return (
    <div className={`${module_style.container}`}>
      <div className={`${module_style.type_card_title}`}>
        Create keywords based on which you want to categorize. Once you do, you
        can select which listing is listed under which keyword category.
      </div>

      {keywords.map((item) => (
        <div
          style={{ alignItems: "center" }}
          className={`mt-3 row no-gutters`}
          key={item.keyword}
        >
          <div className={`col-9`}>
            <input
              disabled={true}
              value={item.keyword}
              className={`${module_style.text_input} mt-2 mr-2 w-100`}
              type="text"
            />
          </div>
          {/* {is_listing_type && !disable_select && <div className={`col-1 ml-2`}><AddCircleOutlinedIcon onClick={() => selectKeyword(item)} style={{ fill: '#1f890e' }} /></div>} */}
          <div className={`col-1 ml-2`}>
            <RemoveCircleOutlined
              onClick={() => removeKeyword(item)}
              className={module_style.remove_icon_style}
            />
          </div>
        </div>
      ))}
      {keyword_title.data.map((item, index) => (
        <div
          style={{ alignItems: "center" }}
          className={`mt-3 row no-gutters`}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
        >
          <div className={`col-9`}>
            <input
              value={item}
              onChange={(e) => {
                let value = e.target.value;
                let temp = keyword_title.data;
                temp[index] = value;
                set_keyword_title({ ...keyword_title, data: temp });
              }}
              className={`${module_style.text_input} w-100 mt-2`}
              type="text"
              placeholder="Ex: Dance"
            />
          </div>
          {keyword_title.data.length > 1 && (
            <div className={`col-1 ml-2`}>
              <RemoveCircleOutlined
                onClick={() => removeKeyword(index)}
                style={{ fill: "#C21717" }}
              />
            </div>
          )}
        </div>
      ))}

      <div className={`mt-3 row no-gutters ${module_style.add_keyword_cta}`}>
        <span onClick={addKeyword} className={`action_text mr-2`}>
          Add keyword
        </span>
        <AddCircleOutlinedIcon
          onClick={addKeyword}
          className={module_style.add_icon_style}
        />
      </div>

      {is_desktop && (
        <div onClick={handleAdd} className={`${style.new_save_cta} mt-3`}>
          Save
        </div>
      )}
    </div>
  );
};

export default CreateKeyword;
